// import addUser from './add_user.vue';
import addUser from './form.vue';

export default addUser;
